

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Loading extends Vue {
  @Prop({ default: '18' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#522CDF' }) readonly color?: string;
}
